// src/components/Header.js
import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header style={styles.header}>
      <div style={styles.container}>
        <Link to="/" style={styles.logo}>
          Quadramelo
        </Link>
        <nav>
          <Link to="/login" style={styles.navLink}>Iniciar Sesión</Link>
        </nav>
      </div>
    </header>
  );
};

const styles = {
  header: {
    backgroundColor: '#fff',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
    padding: '1rem 0',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1.5rem',
  },
  logo: {
    fontSize: '1.8rem',
    fontWeight: '700',
    color: '#4361ee',
    textDecoration: 'none',
  },
  navLink: {
    backgroundColor: '#4361ee',
    color: '#fff',
    padding: '0.5rem 1.2rem',
    borderRadius: '8px',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '0.95rem',
  }
};

export default Header;